import { Controller } from "@hotwired/stimulus"

const EXIT_ANIMATION_NAME = "ve-flash-exit"
const EXIT_FALLBACK_MS = 250

export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 4000 },
  }

  connect() {
    this.onAnimationEnd = this.onAnimationEnd.bind(this)
    this.element.addEventListener("animationend", this.onAnimationEnd)
    this.isClosing = false

    if (this.timeoutValue <= 0) return

    this.timeout = window.setTimeout(() => this.dismiss(), this.timeoutValue)
  }

  disconnect() {
    this.clearTimers()
    this.element.removeEventListener("animationend", this.onAnimationEnd)
  }

  dismiss() {
    if (this.isClosing) return

    this.isClosing = true
    window.clearTimeout(this.timeout)
    this.element.classList.add("ve-flash-closing")
    this.removalTimeout = window.setTimeout(() => this.remove(), EXIT_FALLBACK_MS)
  }

  onAnimationEnd(event) {
    if (this.isClosing && event.animationName === EXIT_ANIMATION_NAME) this.remove()
  }

  remove() {
    window.clearTimeout(this.removalTimeout)
    this.element.remove()
  }

  clearTimers() {
    window.clearTimeout(this.timeout)
    window.clearTimeout(this.removalTimeout)
  }
}
